export default "__VITE_ASSET__z5SxMdQ9__"